<template>
  <div>
    <br/>
    <v-card color="primary darken-1">
      <div v-if="showAnimation" style="height: 300px;">
        <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
      </div>
    </v-card>
    <v-row v-show="!showAnimation" class="align-content-space-between justify-space-between">
      <v-col>
        <current-station-cards :flow="flow" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CurrentStationCards from "./CurrentStationCards";
import LoadingAnimation from "../../common/LoadingAnimation";
import moment from "moment";
export default {
  components: {LoadingAnimation, CurrentStationCards},
  props: ['station'],
  name: "CurrentSituationStationCards",
  data() {
    return {
      flow: false,
      loading: false,
      showAnimation:false,
      location: undefined,
    }
  },
  watch:{
    station(val){
      if(val){
        this.location = this.station;
        this.initializeData();
      }
    }
  },
  mounted() {
    this.location = this.station;
    this.initializeData();
  },
  methods:{
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    async initializeData(){
      this.loading = true;
      this.showAnimation = true;
      await this.$store.dispatch('loadFlowForecastsLocationId', {
        type: 'daily',
        source: '2',
        location_id: this.station.locationid,
        initial_date: moment().subtract(2, 'days').utc().startOf("day").format(),
        final_date: moment().utc().startOf("day").format(),
      })
      let flows = await this.$store.getters.flowForecasts;
      this.flow = flows[flows.length-1];
      this.loading = false;
    }
  }
}
</script>

<style scoped>
</style>
